import useSWR, { type SWRResponse } from "swr";
import { useApiClient } from "@/hooks/useApiClient";
import { corporateMasterDetailApiPath, getCorporateMasterDetail } from "../api";
import { inlineErrorSwrOptions } from "./inlineErrorSwrOptions";
import type { CorporateMasterDetail } from "../types";

/**
 * 法人マスタの詳細（集約）を取得する。13桁でない法人番号ではリクエストしない
 * @param corporateNumber 法人番号（13桁）
 * @returns SWRレスポンス。未登録（404）は data=null
 */
export const useCorporateMasterDetail = (
  corporateNumber: string
): SWRResponse<CorporateMasterDetail | null, Error> => {
  const { apiClient } = useApiClient();
  return useSWR<CorporateMasterDetail | null, Error>(
    /^\d{13}$/.test(corporateNumber)
      ? corporateMasterDetailApiPath(corporateNumber)
      : null,
    async () => await getCorporateMasterDetail(apiClient, corporateNumber),
    {
      revalidateOnFocus: false,
      ...inlineErrorSwrOptions,
    }
  );
};
